import main_onboard from 'assets/images/main_onboard.png';

const MainOnboard = () => {
  return (
    <div className="hidden md:block flex-1 relative bg-primary/300">
      <div className="absolute inset-x-0 bottom-12 flex justify-center">
        <img src={main_onboard} alt="" className="w-620 h-488" />
      </div>
    </div>
  );
};

export default MainOnboard;